// This file is generated by the Webpack next-flight-loader.
const { createProxy } = require("next/dist/build/webpack/loaders/next-flight-loader/module-proxy")

module.exports = createProxy("/app/node_modules/next/dist/client/image-component.js")
